function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Sorting.css';
import React, { useContext, useMemo, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SortIcon } from "../../../resources/icons/sort-arrows-v1.svg";
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { get, canUseDOM } from '../../../utils';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { SORT_QUERY_NAME } from '../constants';
const OFFER_AND_DEAL_SORTING_ID = 'offer-and-deal-id-value';
const Sorting = _ref => {
  let {
    values,
    deskLabelText,
    mobileLabelText,
    defaultSortValue,
    value,
    clearText,
    setSort,
    /* ctaText, */
    setListingFilter,
    eventsAnalytics,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let history = useHistory();
  const fieldOpenedRef = useRef(null);
  const [fieldVisible, setFieldVisible] = useState(false);
  const valuesHash = useMemo(() => values.reduce((acc, item) => _objectSpread(_objectSpread({}, acc), {}, {
    [get(item, 'sortingIndexPrefix.jss.value')]: get(item, 'displayName')
  }), {}), [values]);
  const renderHighlightedValue = s => {
    if (!s) return s;
    const splitted = s.split(/：|:/); // first for zn language, second for others
    if (splitted.length === 2) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "sorting-button__black-label"
      }, splitted[0], ":"), " ", /*#__PURE__*/React.createElement("span", null, splitted[1]));
    }
    return s;
  };
  const hideDD = e => {
    if (fieldOpenedRef.current) {
      const mobileDevice = window.matchMedia(`(max-width: 991px)`).matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest(`#${OFFER_AND_DEAL_SORTING_ID}`)) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(() => {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    id: OFFER_AND_DEAL_SORTING_ID
  }, /*#__PURE__*/React.createElement("div", {
    className: `sorting-button ${fieldVisible ? 'sorting-button--active' : ''}`,
    onClick: () => {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "d-lg-none sorting-button__text"
  }, renderHighlightedValue(defaultSortValue === value ? deskLabelText : valuesHash[value])), /*#__PURE__*/React.createElement("span", {
    className: "d-none d-lg-inline sorting-button__text"
  }, renderHighlightedValue(defaultSortValue === value ? deskLabelText : valuesHash[value])), /*#__PURE__*/React.createElement(SortIcon, {
    className: "sorting-button__icon"
  })), fieldVisible && /*#__PURE__*/React.createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, mobileLabelText), defaultSortValue !== value && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: () => {
      setFieldVisible(false);
      deleteQueryString(SORT_QUERY_NAME, history);
      setSort(defaultSortValue);
      setListingFilter();
    }
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "sorting-values-list"
  }, /*#__PURE__*/React.createElement("li", {
    className: `sorting-values-list__item ${value === defaultSortValue ? 'sorting-values-list__item--active' : ''}`,
    onClick: () => {
      setFieldVisible(false);
      deleteQueryString(SORT_QUERY_NAME, history);
      setSort(defaultSortValue);
      setListingFilter();
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['sortingParamAnalytics'], params), defaultSortValue || deskLabelText);
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "sorting-values-list__item-btn"
  }, deskLabelText)), values.map(sortItem => {
    const itemValue = get(sortItem, 'sortingIndexPrefix.jss.value');
    const itemLabel = get(sortItem, 'displayName');
    return /*#__PURE__*/React.createElement("li", {
      className: `sorting-values-list__item ${value === itemValue ? 'sorting-values-list__item--active' : ''}`,
      key: itemValue,
      onClick: () => {
        setFieldVisible(false);
        addQueryString(SORT_QUERY_NAME, itemValue, history);
        setSort(itemValue);
        setListingFilter();
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['sortingParamAnalytics'], params), itemValue);
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "sorting-values-list__item-btn"
    }, itemLabel));
  })))));
};
export default Sorting;
export const commonStyles = "coo2zl";
export const ltrStyles = "l1mbsoo";
export const rtlStyles = "ran4knc";